<template>
  <div class="examination-list-table" ref="table">
    <div class="table-header">
      <div class="row" :style="{ maxWidth: `${tableBodyWidth}px` }">
        <div class="cell date">検査日</div>
        <div class="cell examination-name">検査名</div>
        <div class="cell blood-flg">血液検査</div>
        <div class="cell file-name">ファイル名</div>
        <div class="cell buttons" />
      </div>
    </div>
    <div class="table-body" ref="tableBody">
      <div
        v-for="(examination, index) in examinations"
        class="row"
        :key="`examination-${index}`"
        :style="{ maxWidth: `${tableBodyWidth}px` }"
      >
        <examination-list-table-row-group
          v-if="examination.resultTopicClasses"
          :result-group="examination"
          @click-print="emitClick('click-print', examination)"
        />
        <examination-list-table-row-file
          v-else
          :pdf-file="examination"
          @click-delete="emitClick('click-delete', examination)"
          @click-edit="emitClick('click-edit', examination)"
          @click-pdf="emitClick('click-pdf', examination)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ExaminationListTableRowFile from '@/components/parts/molecules/ExaminationListTableRowFile'
import ExaminationListTableRowGroup from '@/components/parts/molecules/ExaminationListTableRowGroup'

export default {
  name: 'ExaminationListTable',

  components: {
    ExaminationListTableRowFile,
    ExaminationListTableRowGroup
  },

  props: {
    examinations: { type: Array, default: () => [] }
  },

  data() {
    return {
      observer: null,
      tableBodyWidth: ''
    }
  },

  mounted() {
    this.observer = new ResizeObserver(() => {
      if (this.examinations.length > 0) {
        const { clientWidth } = this.$refs.tableBody
        this.tableBodyWidth = clientWidth
      }
    })
    this.observer.observe(this.$refs.table)
  },

  beforeDestroy() {
    this.observer.disconnect()
  },

  methods: {
    emitClick(eventName, examination) {
      // examination -> pdfFile or resultGroup
      this.$emit(eventName, examination)
    }
  }
}
</script>

<style lang="scss" scoped>
$border-color: #{$light-grey};
.examination-list-table {
  width: 100%;
  > .table-header {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    border: 1px solid #{$light-grey};
    font-size: 15px;
    background-color: #{$pale};
    > .row {
      box-sizing: border-box;
      display: flex;
      height: 100%;
      > .cell {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 5px 8px;
        & ~ .cell {
          border-left: 1px solid #{$skin};
        }
        &.date {
          max-width: 220px;
          min-width: 220px;
        }
        &.examination-name {
          flex: 2;
        }
        &.blood-flg {
          max-width: 120px;
          min-width: 120px;
        }
        &.file-name {
          flex: 3;
        }
        &.buttons {
          max-width: 250px;
          min-width: 250px;
          border-left: 1px solid transparent;
        }
      }
    }
  }
  > .table-body {
    box-sizing: border-box;
    width: 100%;
    overflow-y: scroll;
    font-size: 15px;
    border: solid #{$light-grey};
    border-width: 0px 1px 1px 1px;
    > .row {
      width: 100%;
      &:nth-child(even) {
        background-color: #{$white_f7};
      }
    }
    > .row ~ .row {
      border-top: 1px solid #{$light-grey};
    }
  }
}
</style>
